var ExternalLinks, isBlackListedLink, isLinkToEmptyUrl, isLinkToExternalUrl, isLinkToJs, isLinkToPdf, isMailToLink, isWhiteListedLink;

ExternalLinks = window.ExternalLinks != null ? window.ExternalLinks : window.ExternalLinks = {};

isMailToLink = function(obj) {
  return obj.href.match(/^mailto\:/);
};

isLinkToPdf = function(obj) {
  return /.pdf$/.test(obj.href);
};

isLinkToJs = function(obj) {
  return obj.href.match(/^javascript\:/);
};

isLinkToEmptyUrl = function(obj) {
  return obj.href.match(/^$/);
};

isLinkToExternalUrl = function(obj) {
  return obj.hostname.indexOf(location.hostname.replace('www.', '')) === -1;
};

isWhiteListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

isBlackListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a.discussion-links.comments', '.diy-gift-card-msg a', '#buy-link', '#options a', '.external-buy'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

$.expr[":"].external = function(obj, index, meta, stack) {
  return (isLinkToExternalUrl(obj) || isLinkToPdf(obj) || isWhiteListedLink(obj)) && !(isMailToLink(obj) || isLinkToJs(obj) || isLinkToEmptyUrl(obj) || isBlackListedLink(obj));
};

ExternalLinks.init = function(payload, done) {
  return $(function() {
    $("a:external").click(function(e) {
      e.preventDefault();
      return window.open($(this).attr('href'), "_blank");
    });
    return done();
  });
};

module.exports = ExternalLinks;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2V4dGVybmFsX2xpbmtzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvZGVhbC9mcm9udGVuZC9leHRlcm5hbF9saW5rcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxhQUFBLGtDQUFnQixNQUFNLENBQUMsZ0JBQVAsTUFBTSxDQUFDLGdCQUFnQjs7QUFFdkMsWUFBQSxHQUFlLFNBQUMsR0FBRDtTQUNiLEdBQUcsQ0FBQyxJQUFJLENBQUMsS0FBVCxDQUFlLFdBQWY7QUFEYTs7QUFHZixXQUFBLEdBQWMsU0FBQyxHQUFEO1NBQ1osT0FBTyxDQUFDLElBQVIsQ0FBYSxHQUFHLENBQUMsSUFBakI7QUFEWTs7QUFHZCxVQUFBLEdBQWEsU0FBQyxHQUFEO1NBQ1gsR0FBRyxDQUFDLElBQUksQ0FBQyxLQUFULENBQWUsZUFBZjtBQURXOztBQUdiLGdCQUFBLEdBQW1CLFNBQUMsR0FBRDtTQUNqQixHQUFHLENBQUMsSUFBSSxDQUFDLEtBQVQsQ0FBZSxJQUFmO0FBRGlCOztBQUduQixtQkFBQSxHQUFzQixTQUFDLEdBQUQ7U0FDcEIsR0FBRyxDQUFDLFFBQVEsQ0FBQyxPQUFiLENBQXFCLFFBQVEsQ0FBQyxRQUFRLENBQUMsT0FBbEIsQ0FBMEIsTUFBMUIsRUFBa0MsRUFBbEMsQ0FBckIsQ0FBQSxLQUErRCxDQUFDO0FBRDVDOztBQUd0QixpQkFBQSxHQUFvQixTQUFDLEdBQUQ7QUFDbEIsTUFBQTtFQUFBLFNBQUEsR0FBWSxDQUFDLGVBQUQ7RUFDWixJQUFBLEdBQU8sQ0FBQSxDQUFFLEdBQUY7QUFDUCxPQUFBLDJDQUFBOztRQUEyQyxJQUFJLENBQUMsRUFBTCxDQUFRLFFBQVI7QUFBM0MsYUFBTzs7QUFBUDtBQUNBLFNBQU87QUFKVzs7QUFNcEIsaUJBQUEsR0FBb0IsU0FBQyxHQUFEO0FBQ2xCLE1BQUE7RUFBQSxTQUFBLEdBQVksQ0FBQyx5Q0FBRCxFQUE0QyxzQkFBNUMsRUFBb0UsV0FBcEUsRUFBaUYsWUFBakYsRUFBK0YsZUFBL0Y7RUFDWixJQUFBLEdBQU8sQ0FBQSxDQUFFLEdBQUY7QUFDUCxPQUFBLDJDQUFBOztRQUEyQyxJQUFJLENBQUMsRUFBTCxDQUFRLFFBQVI7QUFBM0MsYUFBTzs7QUFBUDtBQUNBLFNBQU87QUFKVzs7QUFNcEIsQ0FBQyxDQUFDLElBQUssQ0FBQSxHQUFBLENBQUksQ0FBQyxRQUFaLEdBQXVCLFNBQUMsR0FBRCxFQUFNLEtBQU4sRUFBYSxJQUFiLEVBQW1CLEtBQW5CO1NBQ3JCLENBQUMsbUJBQUEsQ0FBb0IsR0FBcEIsQ0FBQSxJQUE0QixXQUFBLENBQVksR0FBWixDQUE1QixJQUFnRCxpQkFBQSxDQUFrQixHQUFsQixDQUFqRCxDQUFBLElBQTZFLENBQUksQ0FBQyxZQUFBLENBQWEsR0FBYixDQUFBLElBQXFCLFVBQUEsQ0FBVyxHQUFYLENBQXJCLElBQXdDLGdCQUFBLENBQWlCLEdBQWpCLENBQXhDLElBQWlFLGlCQUFBLENBQWtCLEdBQWxCLENBQWxFO0FBRDVEOztBQUd2QixhQUFhLENBQUMsSUFBZCxHQUFxQixTQUFDLE9BQUQsRUFBVSxJQUFWO1NBQ25CLENBQUEsQ0FBRSxTQUFBO0lBQ0EsQ0FBQSxDQUFFLFlBQUYsQ0FBZSxDQUFDLEtBQWhCLENBQXNCLFNBQUMsQ0FBRDtNQUNwQixDQUFDLENBQUMsY0FBRixDQUFBO2FBQ0EsTUFBTSxDQUFDLElBQVAsQ0FBWSxDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsSUFBUixDQUFhLE1BQWIsQ0FBWixFQUFrQyxRQUFsQztJQUZvQixDQUF0QjtXQUlBLElBQUEsQ0FBQTtFQUxBLENBQUY7QUFEbUI7O0FBU3JCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
